export const interactiveExperienceCompletedRef: { current: boolean } = { current: false };
